import { useEffect, useState } from 'react'

interface Props {
  size?: number
  color?: string
}

const LOADING_RECOVERY_MS = 9000
const RECOVERY_KEY = 'agroschelive_loading_recovery_done'

export function Spinner({ size = 20, color = 'var(--blue)' }: Props) {
  return (
    <span
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        border: '2px solid rgba(0,0,0,0.1)',
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'spin .7s linear infinite',
        flexShrink: 0,
      }}
    />
  )
}

async function limparCacheDoApp() {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map((registration) => registration.unregister()))
    }

    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(
        keys
          .filter((key) => key.startsWith('agroschelive-'))
          .map((key) => caches.delete(key))
      )
    }
  } catch (error) {
    console.error('[AgroSchelive] Falha ao limpar cache do app:', error)
  }
}

function recarregarComCacheBust() {
  const url = new URL(window.location.href)
  url.searchParams.set('_reload', Date.now().toString())
  window.location.replace(url.toString())
}

export function LoadingScreen({ label = 'Carregando...' }: { label?: string }) {
  const [travado, setTravado] = useState(false)

  useEffect(() => {
    const timer = window.setTimeout(async () => {
      const jaTentouRecuperar = sessionStorage.getItem(RECOVERY_KEY) === '1'

      if (!jaTentouRecuperar) {
        sessionStorage.setItem(RECOVERY_KEY, '1')
        await limparCacheDoApp()
        recarregarComCacheBust()
        return
      }

      setTravado(true)
    }, LOADING_RECOVERY_MS)

    return () => window.clearTimeout(timer)
  }, [])

  async function recuperarAgora() {
    sessionStorage.removeItem(RECOVERY_KEY)
    await limparCacheDoApp()
    recarregarComCacheBust()
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        background: 'var(--bg)',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <Spinner size={32} />
      <p style={{ fontSize: '.82rem', color: 'var(--text-m)', margin: 0 }}>{label}</p>

      {travado && (
        <div style={{ maxWidth: 420 }}>
          <p style={{ fontSize: '.78rem', color: 'var(--text-m)', lineHeight: 1.5, margin: '8px 0 12px' }}>
            O carregamento demorou mais que o esperado. Isso costuma acontecer quando o navegador ainda está usando uma versão antiga do app.
          </p>
          <button
            type="button"
            onClick={recuperarAgora}
            style={{
              border: 0,
              borderRadius: 10,
              padding: '10px 14px',
              background: 'var(--blue)',
              color: '#fff',
              fontWeight: 700,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Corrigir e recarregar
          </button>
        </div>
      )}
    </div>
  )
}
